import { Component } from "@angular/core"
import { NavItemComponent } from "./navigationItem.component"
import { AppRoute } from "@app-types/appRoute"

@Component({
    selector: 'vco-membership-navigation',
    imports: [NavItemComponent],
    template: `
        <details open>
            <summary>Organizations</summary>
            <ul>
                <vco-nav-item label="List All Organizations" [routerLink]="route.organizationList"></vco-nav-item>
                <vco-nav-item label="Create a New Organization" [routerLink]="route.newOrganization"></vco-nav-item>
            </ul>
        </details>

        <details open>
            <summary>Users</summary>
            <ul>
                <vco-nav-item label="List All Users" [routerLink]="route.usersList"></vco-nav-item>
                <vco-nav-item label="Denied Access" [routerLink]="route.deniedUsers"></vco-nav-item>
            </ul>
        </details>
    `
}) export class MembershipNavigationComponent {
    readonly route = {
        organizationList: AppRoute.create(['membership', 'organizations', 'organizationsList']),
        newOrganization: AppRoute.create(['membership', 'organizations', 'newOrganization']),
        usersList: AppRoute.create(['membership', 'users', 'usersList']),
        deniedUsers: AppRoute.create(['membership', 'users', 'deniedUsers']),
    }
}